import { lazy } from 'react';
var LLModal = lazy(function () { return import('../Modal'); });
export default LLModal;
